export default "/static/media/pdf.5cafc4a5f4d5fd5491f2797e5b1630a4.svg";